"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OPERATING_SYSTEMS = {
    OSX: 1,
    WINDOWS: 2,
    LINUX: 3,
    UNKNOWN: -1
};
exports.BROWSERS = {
    FIREFOX: 1,
    OPERA: 2,
    CHROME: 3,
    SAFARI: 4,
    UNKNOWN: -1
};
var BrowserInfo = (function () {
    function BrowserInfo() {
    }
    BrowserInfo.getOS = function () {
        if (window === undefined || window.navigator === undefined || window.navigator.userAgent === undefined) {
            return exports.OPERATING_SYSTEMS.UNKNOWN;
        }
        var useragent = window.navigator.userAgent;
        if (useragent.indexOf("Windows") !== -1) {
            return exports.OPERATING_SYSTEMS.WINDOWS;
        }
        if (useragent.indexOf("Mac") !== -1) {
            return exports.OPERATING_SYSTEMS.OSX;
        }
        if (useragent.indexOf("Windows") !== -1) {
            return exports.OPERATING_SYSTEMS.LINUX;
        }
        return exports.OPERATING_SYSTEMS.UNKNOWN;
    };
    BrowserInfo.getBrowser = function () {
        if (window === undefined || window.navigator === undefined || window.navigator.userAgent === undefined) {
            return exports.BROWSERS.UNKNOWN;
        }
        var useragent = window.navigator.userAgent;
        if (useragent.indexOf("Firefox") !== -1) {
            return exports.BROWSERS.FIREFOX;
        }
        if (useragent.indexOf("Chrome") !== -1) {
            return exports.BROWSERS.CHROME;
        }
        if (useragent.indexOf("Safari") !== -1) {
            return exports.BROWSERS.SAFARI;
        }
        if (useragent.indexOf("Opera") !== -1) {
            return exports.BROWSERS.OPERA;
        }
        return exports.BROWSERS.UNKNOWN;
    };
    return BrowserInfo;
}());
exports.BrowserInfo = BrowserInfo;
//# sourceMappingURL=BrowserInfo.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/grids/selectBehaviours/browserInfo.js
// module id = 76
// module chunks = 0